export enum UserRole {
  ROLE_USER = "ROLE_USER",
  ROLE_TEACHER = "ROLE_TEACHER",
  ROLE_COMPANY = "ROLE_COMPANY",
  ROLE_BOPARTNER = "ROLE_BOPARTNER",
  ROLE_DIRECTOR = "ROLE_DIRECTOR",
  ROLE_SECONDARY_SCHOOL = "ROLE_SECONDARY_SCHOOL",
  ROLE_SCHOOL_CLASS = "ROLE_SCHOOL_CLASS"
}
